import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';

export interface SalesForceLoginResponse {
    sessionId?: string;
    trxId?: string;
    authCode?: string;
    selectedRole?: string;
    userProfile?: {
        employName?: string | null;
        sub?: string;
        emailVerified?: boolean;
        memberNumber?: string | null;
        policyNumber?: string | null;
        username?: string;
        userEmail?: string;
        userPhoneNumber?: string;
        userType?: string | null;
        clientNumber?: string | null;
        subNumber?: string | null;
        selectedRole?: string | null;
    };
}

export interface SalesForceOTPResponse {
    authCode?: string;
    selectedRole?: string;
    userProfile?: {
        employName?: string | null;
        sub?: string;
        emailVerified?: boolean;
        memberNumber?: string | null;
        policyNumber?: string | null;
        username?: string;
        userEmail?: string;
        userPhoneNumber?: string;
        userType?: string | null;
        clientNumber?: string | null;
        subNumber?: string | null;
        selectedRole?: string | null;
    };
}

@Injectable({
    providedIn: 'root'
})
export class SalesForceAuthService {
    private readonly salesForceAuthPath = environment.SALESFORCE_AUTH;
    
    constructor(private readonly http: HttpClient) {}

    private getHeaders(): HttpHeaders {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'X-Language': 'IDN'
        });
    }

    validateCredentials(username: string, password: string): Observable<ApiResponse<SalesForceLoginResponse>> {
        const url = `${this.salesForceAuthPath.baseUrl}${this.salesForceAuthPath.saleLoginPath}/validate-credentials`;
        const body = {
            username,
            password,
            portalId: 'agen'
        };

        return this.http.post<ApiResponse<SalesForceLoginResponse>>(url, body, {
            headers: this.getHeaders()
        });
    }

    submitOTP(sessionId: string, otp: string, trxId: string): Observable<ApiResponse<SalesForceOTPResponse>> {
        const url = `${this.salesForceAuthPath.baseUrl}${this.salesForceAuthPath.saleLoginPath}/submit-otp`;
        const body = {
            sessionId,
            otp,
            trxId
        };

        return this.http.post<ApiResponse<SalesForceOTPResponse>>(url, body, {
            headers: this.getHeaders()
        });
    }

    resendOTP(sessionId: string, sendOtpType: 'wab' | 'email' = 'wab'): Observable<ApiResponse<any>> {
        const url = `${this.salesForceAuthPath.baseUrl}${this.salesForceAuthPath.saleLoginPath}/resend-otp`;
        const body = {
            sessionId,
            sendOtpType
        };

        return this.http.post<ApiResponse<any>>(url, body, {
            headers: this.getHeaders()
        });
    }
}